import { withImageOptimizationQuery } from '@common/utils';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useOverseaDirectBannerService = () => {
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);
  return {
    oversea_direct_banner_image_url:
      withImageOptimizationQuery(product.oversea_direct_banner_image_url, { format: 'webp', quality: 80 }) ??
      product.oversea_direct_banner_image_url,
  };
};
